import { ModalToggleButton } from '$components/ModalToggleButton';
import { ReactNode } from 'react';

export function Footer(props: {
  title: string;
  addresses: ReactNode;
  primaryLinks: ReactNode;
  secondaryLinks: ReactNode;
  socialMedia: ReactNode;
  copyright: string;
}) {
  const {
    title,
    addresses,
    primaryLinks,
    secondaryLinks,
    socialMedia,
    copyright,
  } = props;
  return (
    <footer className="mt-16 lg:mt-32 flex flex-row justify-center">
      <div
        className={`grid
        gap-[16px]
        md:gap-[32px]
        mx-[24px]
        md:mx-[84px]
        grid-cols-[repeat(4,_minmax(0px,_180px))]
        md:grid-cols-[repeat(12,_minmax(0px,_116px))]
      `}
      >
        <div
          className={`
          col-span-4
          md:col-span-12
        `}
        >
          <hr className="w-full h-[1px] bg-grey-20" />
          <div className="my-8 space-y-8 lg:mt-12 lg:mb-6 lg:space-y-12">
            <h3 className="style-heading-xs">{title}</h3>
            <div className="flex flex-col space-y-8 lg:space-y-0 lg:flex-row lg:justify-between">
              {addresses}
              <div className="flex flex-col space-y-2">
                <h4 className="style-heading-xxxs text-grey-60">I want to</h4>
                <div className="flex flex-col space-y-3 2xl:flex-row 2xl:space-x-3 2xl:space-y-0">
                  <ModalToggleButton
                    type={'contactForm'}
                    text={'Contact through form'}
                  />
                  <ModalToggleButton
                    type={'newsletterSignup'}
                    text={'Subscribe to newsletter'}
                    kind={'secondary'}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col">
              <hr className="w-full h-[1px] bg-grey-20" />
              <div
                className={`
                grid gap-[16px] gap-y-[24px]
                grid-cols-[repeat(2,_minmax(0px,_180px))]
                lg:flex lg:flex-row lg:justify-between my-6`}
              >
                {primaryLinks}
                {socialMedia}
              </div>
              <hr className="w-full h-[1px] bg-grey-20" />
              <div className="flex flex-col-reverse lg:space-y-0 lg:flex-row lg:justify-between mt-6">
                <div className="style-body-s text-grey-60 mt-4 lg:mt-0">
                  {copyright}
                </div>
                <div className="flex flex-row space-x-8 items-center">
                  {secondaryLinks}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
